import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { motion, useInView } from 'framer-motion';


import profile1 from '../assets/recommendation/Arunoday.jpeg';
import profile2 from '../assets/recommendation/Pavan.jpeg';
import profile3 from '../assets/recommendation/Jason.jpeg';
import profile4 from '../assets/recommendation/Venubabu.jpeg';
import profile5 from '../assets/recommendation/Ram.jpeg';
import profile6 from '../assets/recommendation/noimage.gif';
import profile7 from '../assets/recommendation/Rajiv.jpeg';
import profile8 from '../assets/recommendation/Prashanth.jpeg';
import profile9 from '../assets/recommendation/Francisco.jpeg';
import profile10 from '../assets/recommendation/Etienne.jpeg';
import profile11 from '../assets/recommendation/Shuhei.jpeg';
import profile12 from '../assets/recommendation/Herbert.jpeg';
import profile13 from '../assets/recommendation/noimage.gif';

const RecommendationsSection = styled.section`
  padding: 100px 10%;
  background-color: var(--color-bg-alt);
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 80px 5%;
  }

  @media (max-width: 576px) {
    padding: 60px 5%;
  }
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  color: var(--color-text);
  margin-bottom: 1.5rem;
  text-align: center;
  position: relative;
  font-weight: 600;
  letter-spacing: 0.5px;

  &:after {
    content: '';
    position: absolute;
    width: 50px;
    height: 3px;
    background-color: var(--color-primary);
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }

  @media (max-width: 576px) {
    font-size: 1.8rem;
    margin-bottom: 1.2rem;
  }
`;

const SectionSubtitle = styled.p`
  font-size: 1.3rem;
  color: var(--color-secondary);
  text-align: center;
  max-width: 700px;
  margin: 0 auto 4rem;
  font-weight: 300;

  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin: 0 auto 3rem;
  }

  @media (max-width: 576px) {
    font-size: 1rem;
    margin: 0 auto 2.5rem;
  }
`;

const RecommendationsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1.5rem;
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

const RecommendationCard = styled(motion.a)`
  display: flex;
  align-items: center;
  padding: 1.5rem;
  background-color: var(--color-card);
  border-radius: 12px;
  box-shadow: 0 4px 15px var(--color-shadow);
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid transparent;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px var(--color-shadow);
    border-color: var(--color-primary);
  }

  @media (max-width: 576px) {
    padding: 1.2rem;
  }
`;

const ProfilePicture = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 1rem;
  border: 2px solid var(--color-primary);
  flex-shrink: 0;

  @media (max-width: 576px) {
    width: 50px;
    height: 50px;
    margin-right: 0.8rem;
  }
`;

const RecommendationContent = styled.div`
  flex: 1;
`;

const RecommenderName = styled.h3`
  font-size: 1.1rem;
  color: var(--color-text);
  margin-bottom: 0.3rem;
  font-weight: 600;

  @media (max-width: 576px) {
    font-size: 1rem;
  }
`;

const RecommenderTitle = styled.p`
  font-size: 0.9rem;
  color: var(--color-secondary);
  margin-bottom: 0.5rem;
  font-weight: 400;
  line-height: 1.3;

  @media (max-width: 576px) {
    font-size: 0.85rem;
  }
`;

const RecommenderCompany = styled.p`
  font-size: 0.8rem;
  color: var(--color-primary);
  font-weight: 500;
  margin: 0;

  @media (max-width: 576px) {
    font-size: 0.75rem;
  }
`;

const ViewAllButton = styled(motion.button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 2rem;
  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));
  color: white;
  text-decoration: none;
  border: none;
  border-radius: 25px;
  font-weight: 600;
  font-size: 1rem;
  margin-top: 3rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  }

  .icon {
    margin-left: 8px;
    font-size: 0.9rem;
  }

  @media (max-width: 576px) {
    padding: 0.8rem 1.5rem;
    font-size: 0.9rem;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const Recommendations = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, threshold: 0.1 });
  const [showAll, setShowAll] = useState(false);

  const recommendationsData = [
    {
      id: 1,
      name: "Arunoday Bhattacharya",
      title: "AMER Head",
      company: "Google",
      profilePic: profile1,
    },
    {
      id: 2,
      name: "Pavan Nuggehalli",
      title: "3GPP Standards",
      company: "Google",
      profilePic: profile2,
    },
    {
      id: 3,
      name: "Jason Schonhoff",
      title: "Volunteer",
      company: "FireFighter",
      profilePic: profile3,
    },
    {
      id: 4,
      name: "Venubabu Bandarupalli",
      title: "Onsite Engineering Manager",
      company: "Anritsu",
      profilePic: profile4,
    },
    {
      id: 5,
      name: "Ram Balakrishnan",
      title: "Engineering Leadership",
      company: "Cisco",
      profilePic: profile5,
    },
    {
      id: 6,
      name: "Rajiv Chandrasekar",
      title: "Enterprise Success Account Manager",
      company: "Commvault",
      profilePic: profile7,
    },
    {
      id: 7,
      name: "Vijendra Ashiwal",
      title: "Senior Engineering Manager",
      company: "Apple",
      profilePic: profile6,
    },
    {
      id: 8,
      name: "Prashanth Rao",
      title: "Senior Product Manager",
      company: "DellEMC",
      profilePic: profile8,
    },
    {
      id: 9,
      name: "Francisco R.",
      title: "PixelTPM",
      company: "Google",
      profilePic: profile9,
    },
    {
      id: 10,
      name: "Etienne Ding",
      title: "Exercise Physiologist",
      company: "AMP Labs",
      profilePic: profile10,
    },
    {
      id: 11,
      name: "Shuhei Kawashima(Kim)",
      title: "RF System Manager",
      company: "Apple",
      profilePic: profile11,
    },
    {
      id: 12,
      name: "Herbert Wong",
      title: "Telecom Engineer",
      company: "Apple",
      profilePic: profile12,
    },
    {
      id: 13,
      name: "Cedric Albuquerque",
      title: "Engineer",
      company: "Broadcom",
      profilePic: profile13,
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 20,
      scale: 0.9
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };

  const displayedRecommendations = showAll ? recommendationsData : recommendationsData.slice(0, 6);

  return (
    <RecommendationsSection id="recommendations" ref={sectionRef}>
      <SectionTitle>Professional Recommendations</SectionTitle>
      <SectionSubtitle>
        What colleagues and industry leaders say about working with me
      </SectionSubtitle>

      <RecommendationsGrid
        as={motion.div}
        variants={containerVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
      >
        {displayedRecommendations.map((recommendation) => (
          <RecommendationCard
            key={recommendation.id}
            href="https://www.linkedin.com/in/surendarvp/details/recommendations/"
            target="_blank"
            rel="noopener noreferrer"
            variants={cardVariants}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <ProfilePicture
              src={recommendation.profilePic}
              alt={`${recommendation.name} profile`}
              onError={(e) => {
                e.target.src = [profile1, profile2, profile3, profile4, profile5, profile6, profile7, profile8, profile9, profile10, profile11, profile12, profile13];
              }}
            />
            <RecommendationContent>
              <RecommenderName>{recommendation.name}</RecommenderName>
              <RecommenderTitle>{recommendation.title}</RecommenderTitle>
              <RecommenderCompany>{recommendation.company}</RecommenderCompany>
            </RecommendationContent>
          </RecommendationCard>
        ))}
      </RecommendationsGrid>

      <ButtonContainer>
        {showAll ? (
          <ViewAllButton
            onClick={() => {
              setShowAll(false);
            }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Close Recommendations
            <span className="icon">
              <i className="fas fa-times"></i>
            </span>
          </ViewAllButton>
        ) : (
          <ViewAllButton
            onClick={() => {
              setShowAll(true);
            }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            View All Recommendations
            {/* <span className="icon">
              <i className="fas fa-external-link-alt"></i>
            </span> */}
          </ViewAllButton>
        )}
      </ButtonContainer>
    </RecommendationsSection>
  );
};

export default Recommendations;